import React from 'react';
import PropTypes from 'prop-types';
import {
  Avatar,
  IconButton,
  ListItem,
  Typography,
  makeStyles,
  Box,
  useTheme
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  userInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flex: 1,
  },
  avatar: {
    width: 32,
    height: 32,
    fontSize: 14,
  },
  nameAndDate: {
    display: 'flex',
    flexDirection: 'column',
  },
  noteText: {
    marginTop: theme.spacing(1),
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
  actions: {
    display: 'flex',
    gap: theme.spacing(1),
  }
}));

export default function ContactNotesDialogListItem({ note, deleteItem, editItem }) {
  const classes = useStyles();

  return (
    <ListItem alignItems="flex-start" disableGutters>
      <Box className={classes.container}>
        <Box className={classes.header}>
          <Box className={classes.userInfo}>
            <Avatar
              className={classes.avatar}
              alt={note?.user?.name || 'Usuário'}
              src={
                note?.user?.profileImage
                  ? `${process.env.REACT_APP_BACKEND_URL}/public/company${note?.user?.companyId}/user/${note?.user?.profileImage}`
                  : undefined
              }
            >
              {(note?.user?.name ? String(note.user.name).charAt(0) : '?').toUpperCase()}
            </Avatar>
            <Box className={classes.nameAndDate}>
              <Typography variant="body2" color="textPrimary">
                {note?.user?.name || 'Usuário'}
              </Typography>
              <Typography variant="caption" color="textSecondary">
                {moment(note.createdAt).format('DD/MM/YY HH:mm')}
              </Typography>
              {note.ticket && (
                <Typography variant="caption" color="textSecondary">
                  {`Ticket #${note.ticket.id}${note.ticket.status ? ` • ${note.ticket.status}` : ""}`}
                </Typography>
              )}
            </Box>
          </Box>
          <Box className={classes.actions}>
            <IconButton onClick={() => editItem(note)} size="small">
              <EditIcon fontSize="small" />
            </IconButton>
            <IconButton onClick={() => deleteItem(note)} size="small">
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Box>
        </Box>
        <Typography variant="body2" className={classes.noteText}>
          {note.note}
        </Typography>
      </Box>
    </ListItem>
  );
}

ContactNotesDialogListItem.propTypes = {
  note: PropTypes.object.isRequired,
  deleteItem: PropTypes.func.isRequired,
  editItem: PropTypes.func.isRequired,
};
